export default __webpack_public_path__ + "static/media/iconPaperBringToForward.a2bd6451.svg";